import { Link } from "react-router-dom";
import { Shield, Download, Cookie, FileText } from "lucide-react";

export default function PrivacyLinks({ className = "" }) {
  return (
    <div className={`flex flex-col items-center gap-3 text-xs text-zinc-500 ${className}`} data-testid="privacy-links">
      <div className="flex items-center gap-1.5 text-zinc-400">
        <Shield className="w-3 h-3" />
        <span>Proseguendo accetti le nostre condizioni sul trattamento dei dati</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {/* Privacy Policy */}
        <Link
          to="/privacy"
          target="_blank"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#163321]/15 bg-[#163321]/5 text-[#163321] font-medium hover:bg-[#163321]/10 hover:border-[#163321]/30 transition-all"
          data-testid="privacy-link"
        >
          <FileText className="w-3 h-3" /> Leggi Privacy Policy
        </Link>
        <a
          href="/privacy?download=1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#163321]/15 bg-white text-[#163321] font-medium hover:bg-[#163321]/5 hover:border-[#163321]/30 transition-all"
          data-testid="privacy-download"
          title="Scarica Privacy Policy in PDF"
        >
          <Download className="w-3 h-3" /> Scarica PDF
        </a>

        <span className="text-zinc-300 hidden sm:inline mx-1">|</span>

        {/* Cookie Policy */}
        <Link
          to="/cookie-policy"
          target="_blank"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#163321]/15 bg-[#163321]/5 text-[#163321] font-medium hover:bg-[#163321]/10 hover:border-[#163321]/30 transition-all"
          data-testid="cookie-link"
        >
          <Cookie className="w-3 h-3" /> Leggi Cookie Policy
        </Link>
        <a
          href="/cookie-policy?download=1"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#163321]/15 bg-white text-[#163321] font-medium hover:bg-[#163321]/5 hover:border-[#163321]/30 transition-all"
          data-testid="cookie-download"
          title="Scarica Cookie Policy in PDF"
        >
          <Download className="w-3 h-3" /> Scarica PDF
        </a>
      </div>
    </div>
  );
}
